import script from "./MemberGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberGallery.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/style/mainpage.css?vue&type=style&index=0&id=04e7cf1a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e7cf1a"]])

export default __exports__